import '../../styles/messages.css'
import '../../styles/customLink.css'
import '../../Chatbot/ActionProvider'
import FeedbackIcons from '../../Containers/FeedbackIcons'
import TextWithHttpsLinks from './TextWithHttpsLinks'

const AnswerFaqComponent = ({ answerFaq, queryId }) => {

    return (
        <div className="message-container">
            <TextWithHttpsLinks text={answerFaq.answer} />
            <FeedbackIcons queryId={queryId} resultId={answerFaq.resultId} />
        </div>
    )
}

export default AnswerFaqComponent